const FlexColumn = ({children, widthClass}) => {
    return (
        <div className={`flex_column${widthClass?` ${widthClass}`:""}`}>
            {children}
        </div>
    )
}

export default FlexColumn;